module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>{{ InputCustomFieldFormCtrl.field.label }}</label>\n    </dt>\n    <dd>\n        <input\n            ng-class=\"InputCustomFieldFormCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"{{ InputCustomFieldFormCtrl.field.label }}\"\n            ng-model=\"InputCustomFieldFormCtrl.field.value\"\n        />\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/custom_fields/input/input.html
// module id = 662
// module chunks = 0